import React, { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Card } from "@mui/material";
import FileUploader from "../../FileUploader";
import { endpoints } from "../../../services/apiurl";
import Input from "../../UI/Input/Input";
import PageTitle from "../../UI/PageTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";

const AddHomeSlider = () => {
  let history = useHistory();
  const [cat, setCat] = useState({
    name: "",
    status: "",
    path_id: "",
    path_url: "",
    button_name: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileSelectSuccess = (file) => {
    setSelectedFile(file);
  };

  const handleFileSelectError = ({ error }) => {
    alert(error);
  };
  const [loading, setloading] = useState(false);

  const { name, status, path_id, path_url, button_name } = cat;
  const onInputChange = (e) => {
    setCat({ ...cat, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!selectedFile) {
      alert("Please select image");
      return false;
    }
    setloading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("path_id", path_id);
    formData.append("path_url", path_url);
    formData.append("button_name", button_name);
    formData.append("image", selectedFile);
    formData.append("status", status);
    await axios.post(endpoints.addHomeSlider, formData).then((response) => {
      setloading(false);
      history.goBack();
    });
  };
  return (
    <div className="ui main">
      <PageTitle title="Add Home Slider" linkurl="" linkTitle="" />

      <Card className="px-3 py-3">
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <Input
              id="name"
              label="Name"
              type="text"
              name="name"
              place="Name"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={name}
              class="col col-6"
            />

            <div className="col col-6">
              <label>Status</label>
              <select
                name="status"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Status</option>
                <option value="2">InActive</option>
                <option value="1">Active</option>
              </select>
            </div>
          </div>

          <div className="row">
            <Input
              id="path_id"
              label="Path ID"
              type="text"
              name="path_id"
              place="Path ID"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={path_id}
              class="col col-6"
            />

            <Input
              id="path_url"
              label="Path Url"
              type="text"
              name="path_url"
              place="Path Url"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={path_url}
              class="col col-6"
            />
          </div>

          <div className="row">
            <div className="col col-6">
              <label>Image</label>
              <FileUploader
                onFileSelectSuccess={handleFileSelectSuccess}
                onFileSelectError={handleFileSelectError}
              />

              {selectedFile && (
                <div>
                  <p>Preview:</p>
                  <img
                    src={URL.createObjectURL(selectedFile)}
                    alt="Selected Logo"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              )}
            </div>
            <Input
              id="button_name"
              label="Button Name"
              type="text"
              name="button_name"
              place="Button Name"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={button_name}
              class="col col-6"
            />
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AddHomeSlider;
